import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';

import { Features } from 'APP/packages/features/Features';
import { Group } from 'APP/store/Groups/Group';
import { User } from 'APP/store/Users/User/User';
import Entities from 'STORE';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { ISenderNamePresenterLocalStore } from './SenderName.types';

export const useSenderNamePresenter = (message: ChatMessage): ISenderNamePresenterLocalStore => {
  const source = useAsObservableSource({ message });

  const presenter = useLocalStore<ISenderNamePresenterLocalStore>(() => ({
    get isShow(): boolean {
      return source.message.isSenderNameShow;
    },

    get isSavedMessages(): boolean {
      return Boolean(presenter.group?.isSavedMessages);
    },

    get isForwardToSavedMessages(): boolean {
      return source.message.isForwardToSavedMessages;
    },

    get senderUser(): User {
      return source.message.senderUser as User;
    },

    get group(): Group | null {
      return Entities.GroupsStore.getGroupById(source.message.groupId);
    },

    get withMeInAdmins(): boolean {
      if (!Features.isBanUserEnabled()) {
        return false;
      }
      return Boolean(presenter.group?.withMeInAdmins);
    },
  }));

  return presenter;
};
